import { render, staticRenderFns } from "./CellsContent.vue?vue&type=template&id=22b5433e"
import script from "./CellsContent.vue?vue&type=script&lang=js"
export * from "./CellsContent.vue?vue&type=script&lang=js"
import style0 from "./CellsContent.vue?vue&type=style&index=0&id=22b5433e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports